import { Component, Input, signal } from '@angular/core';
import {
    FrameworkColumn,
    ITableCellValueRenderer,
    SafeAny,
} from '@pf/shared-common';
import { IItemFragment } from '@pf/shared/util-platform';
import { CpwItemImageComponent } from './cpw-item-image.component';

/**
 * Table cell renderer for an item column. Uses the shared {@link
 * CpwItemImageComponent} (same as the picking screens) so the thumbnail loads a
 * real preview URL and, on click, opens the item-details drawer. Falls back to a
 * tappable placeholder when the item has no image.
 */
@Component({
    selector: 'cpw-item-image-renderer',
    standalone: true,
    imports: [CpwItemImageComponent],
    template: `
        <div class="cpw-item-cell">
            @if (item()?.id; as itemId) {
                <cpw-item-image
                    [itemId]="itemId"
                    [width]="40"
                    [height]="40"></cpw-item-image>
            }
            <div class="cpw-item-cell__text">
                <strong>{{ item()?.code }}</strong>
                <span>{{ item()?.name }}</span>
            </div>
        </div>
    `,
    styles: [
        `
            :host {
                display: block;
            }

            .cpw-item-cell {
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: var(--pf-gap);
            }

            .cpw-item-cell__text {
                display: flex;
                flex-direction: column;
                min-width: 0;
                font-size: smaller;

                strong,
                span {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        `,
    ],
})
export class CpwItemImageRendererComponent implements ITableCellValueRenderer {
    @Input() set value(item: IItemFragment | null | undefined) {
        this.item.set(item);
    }
    @Input() column!: FrameworkColumn;
    @Input() row!: SafeAny;

    item = signal<IItemFragment | null | undefined>(null);
}
